/**
 * Top Cities Utility
 *
 * Given a state abbreviation, returns the top cities with search URLs.
 * Ported from legacy areaUtils_exploreLinks / areaUtils_getTopCities.
 */

import statesData from './states.json';

type StateEntry = {
  id: number;
  name: string;
  abbreviation: string;
  topCities: Array<string>;
  resourceId: string;
};

export type CityLink = {
  name: string;
  uri: string;
};

/**
 * Converts a slug like "san-francisco" to "San Francisco".
 */
function dashToTitleCase(slug: string): string {
  return slug
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

/**
 * Returns top city links for a given state abbreviation.
 * Each link includes a display name and a URI pointing to the apartments-for-rent SRP.
 *
 * @param stateAbbreviation - Two-letter state code (e.g., "CA", "NY")
 * @returns Array of city links, or empty array if state not found
 */
export function getTopCitiesForState(stateAbbreviation: string): Array<CityLink> {
  const state = (statesData as Array<StateEntry>).find(
    (s) => s.abbreviation.toUpperCase() === stateAbbreviation.toUpperCase(),
  );

  if (!state) {
    return [];
  }

  return state.topCities.map((slug) => ({
    name: `${dashToTitleCase(slug)} apartments for rent`,
    uri: `/${slug}-${state.abbreviation.toLowerCase()}/apartments-for-rent`,
  }));
}
